module.exports = __webpack_public_path__ + "img/park-live-logo-mobile.b7ec6308.svg";